import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "write", "dictate"];

  static values = {
    write: String,
    dictate: String,
  };

  connect() {
    this.showDictate = true;
    this.writeTarget.classList.add("hidden");
  }

  async toggle() {
    this.showDictate = !this.showDictate;
    this.dictateTarget.classList.toggle("hidden", !this.showDictate);
    this.writeTarget.classList.toggle("hidden", this.showDictate);
    this.buttonTarget.textContent = this.showDictate
      ? this.writeValue
      : this.dictateValue;
  }
}
